var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.linkUrl)?_c('a',{attrs:{"href":_vm.linkUrl,"target":_vm.linkTarget}},[_vm._t("default")],2):(_vm.product.type !== _vm.ProductType.BANNER)?_c('router-link',{attrs:{"to":_vm._f("link")(_vm.product)}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }